<template>
  <v-container fluid>
    <alert-unsaved-changes v-if="unsavedChanges && edit"></alert-unsaved-changes>
    <v-form ref="managementForm">
      <v-row v-if="edit">
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t('optional-info') }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-row>
                  <v-col cols="12" md="6" sm="12">
                    <label>Equipment Service Level</label>
                    <p class="label-info">
                      Webpage with the information about the levels of <br />
                      perfomance that a Provider is expceted to deliver.
                    </p>
                    <v-text-field
                      v-model.trim="optionalEquipment.equipmentServiceLevel"
                      outlined
                      :placeholder="'Paste a URL'"
                      prepend-inner-icon="mdi-link-variant"
                      clearable
                      @input="handleUrl"
                    >
                    </v-text-field>
                    <v-alert v-if="!isValidUrl" type="error" class="subtitle-2 py-2">
                      Please enter a valid URL
                    </v-alert>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Buttons -->
      <v-row class="my-5" justify="end">
        <v-btn
          v-if="unsavedChanges && edit"
          @click="cancel"
          outlined
          class="black--text font-weight-bold mx-2"
          rounded
          x-large
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          v-if="unsavedChanges && edit"
          @click="updateEquipmentManagementInfo"
          depressed
          rounded
          x-large
          color="primary200"
          class="white--text font-weight-bold"
        >
          {{ $t('update') }}
        </v-btn>
        <v-btn
          v-if="!unsavedChanges"
          depressed
          rounded
          x-large
          color="black"
          @click="back"
          outlined
          class="black--text font-weight-bold mx-2"
        >
          <v-icon color="black">$vuetify.icons.back</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn
          v-if="!unsavedChanges"
          depressed
          rounded
          x-large
          color="primary200"
          @click="next"
          class="white--text font-weight-bold"
          >{{ $t('next') }}
          <v-icon color="white">$vuetify.icons.next</v-icon>
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import AlertUnsavedChanges from '@/components/shared/helpers/AlertUnsavedChanges';
import util from '@/mixins/util.js';

export default {
  name: 'EquipmentManagementInfo',
  mixins: [util],
  components: { AlertUnsavedChanges },
  data: () => ({
    optionalEquipment: {
      equipmentServiceLevel: '',
    },
    isValidUrl: true,
    unsavedChanges: false,
    dataLoaded: false,
    status: false,
    initialStatus: {},
  }),
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    published: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    optionalEquipment: {
      deep: true,
      handler() {
        if (!this.dataLoaded) return;
        this.unsavedChanges =
          this.optionalEquipment.equipmentServiceLevel !==
          this.initialOptionalEquipment.equipmentServiceLevel;
      },
    },
    published: {
      deep: true,
      handler() {
        if (!this.dataLoaded) return;
        this.unsavedChanges = this.status !== this.published;
      },
    },
  },
  mounted() {
    if (this.edit) {
      this.getEquipmentIdManagementInfo();
    }
  },
  methods: {
    back() {
      this.$emit('tab', 3);
    },
    next() {
      this.$emit('tab', 5);
    },
    getEquipmentIdManagementInfo() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/equipment/${id}`)
        .then(response => {
          console.log('Get Equipment Management Info', response.data);

          this.optionalEquipment.equipmentServiceLevel = response.data.equipmentServiceLevel;

          this.initialOptionalEquipment = {
            equipmentServiceLevel: response.data.equipmentServiceLevel,
          };

          this.status = response.data.published;

          this.initialStatus = {
            published: response.data.published,
          };
          this.$emit('status', this.initialStatus.published);

          this.dataLoaded = true;
        })
        .catch(error => {
          console.error('Error fetching equipment data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    updateEquipmentManagementInfo() {
      const id = this.$route.params.id;
      const equipmentUpdateData = {
        published: this.published,
        id: id,
        equipmentServiceLevel: this.optionalEquipment.equipmentServiceLevel || null,
      };

      if (this.isValidUrl) {
        this.axios
          .put('api/v1/equipment/management-info', equipmentUpdateData)
          .then(response => {
            console.log('Equipment info updated successfully:', response.data);
            EventBus.$emit('snackbar', {
              text: 'Equipment Updated Successfully',
            });

            this.initialStatus = this.status;
            this.unsavedChanges = false;
            this.$emit('updatedChanges', true);

            this.getEquipmentIdManagementInfo();
          })
          .catch(error => {
            console.error('Error updating equipment info:', error);
          });
      }
    },
    handleUrl(value) {
      if (value) {
        this.validateUrl(value);
      } else {
        this.isValidUrl = true;
      }
    },
    validateUrl() {
      this.isValidUrl = this.canParse(this.optionalEquipment.equipmentServiceLevel);
    },
    canParse(link) {
      if (!/^https?:\/\//i.test(link)) {
        return false;
      }
      try {
        new URL(link);
        return true;
      } catch (e) {
        return false;
      }
    },
    cancel() {
      this.getEquipmentIdManagementInfo();
    },
  },
};
</script>
